<template>
    <div class="offline-sign">
        <div class="offline-header">线下签署</div>

        <div class="step-box">
            <div class="step">
                <div class="step-item">
                    <div class="step-index">1</div>
                    <div class="step-title">
                        <div class="text">下载合同文件</div>
                        <div class="value">
                            <img class="icon-upload" @click="downloadAll"
                                src="../../../../../assets/images/personalSign/icon-download.png" alt="">
                        </div>
                    </div>
                    <div class="step-content">
                        <div class="item" v-for="(item, index) in fileArray" :key="item.id">
                            <div class="message">
                                <img class="icon-pdf" src="../../../../../assets/images/personalSign/icon-pdf.png"
                                    alt="">
                                <div class="name">合同{{ index + 1 }}：{{ item.fileName }}</div>
                            </div>
                        </div>
                        <div class="item" v-if="contractSignLastOverInfo">
                            <div class="other-view">
                                <div>
                                    <span class="bold" v-if="contractSignLastOverInfo.signUser">{{ contractSignLastOverInfo.signUser.name }}</span>
                                    <el-tag class="tag" size="mini" type="danger" effect="plain">已签</el-tag>
                                </div>
                                <div class="time">{{ contractSignLastOverInfo.signStatusTime }}</div>
                            </div>
                        </div>
                        <!-- <div class="item">
                            <div class="message">
                                <img class="icon-pdf" src="../../../../../assets/images/personalSign/icon-pdf.png"
                                    alt="">
                                <div class="name">合同1：合同名称</div>
                            </div>
                            <div class="other-view">
                                <div>
                                    <span class="bold">旺季</span>
                                    <el-tag class="tag" size="mini" type="danger" effect="plain">已签</el-tag>
                                </div>
                                <div class="time">2022-12-01 16:01:39</div>
                            </div>
                            <div class="other-view red">
                                初始合同
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="step-item">
                    <div class="step-index">2</div>
                    <div class="step-title">
                        <div class="text">加盖实体印章并扫描</div>
                    </div>
                </div>
                <div class="step-item">
                    <div class="step-index">3</div>
                    <div class="step-title">
                        <div class="text">上传扫描后的合同</div>
                    </div>
                    <div class="size-tip">（请上传10M以内的文件）</div>
                    <div class="step-content">
                        <div class="item" v-for="(item, index) in uploadFileArray" :key="item.id">
                            <div class="message">
                                <img class="icon-pdf" src="../../../../../assets/images/personalSign/icon-pdf.png"
                                    alt="">
                                <div class="name">合同1：{{ item.fileName }}</div>
                                <el-upload accept=".pdf" :show-file-list="false" :data="{ index, ...item }" :http-request="httpRequest">
                                    <img class="icon-upload"
                                        src="../../../../../assets/images/personalSign/icon-upload.png" alt="">
                                </el-upload>
                            </div>
                            <div class="other-view" v-if="item.filePathName">
                                {{ item.filePathName }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- <div class="buttons">
            <el-button size="small" class="back-button">返 回</el-button>
            <el-button type="primary" class="submit-button" size="small">提 交</el-button>
        </div> -->
    </div>
</template>
<script>
import BaseApi from "@lib/baseApi.js";
import download from "@lib/download.js";
import axios from "axios";
import Util from "@lib/util.js";
export default {
    props: {
        contractDetail: {
            type: Object,
            default: () => {
                return {}
            }
        },

        fileArray: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data() {
        return {

        };
    },
    computed: {
        uploadFileArray() {
            return JSON.parse(JSON.stringify(this.fileArray));
        },
        contractSignLastOverInfo() {
            if (this.contractDetail.contractSignList) {
                let arr = this.contractDetail.contractSignList;
                arr  = this.contractDetail.contractSignList.filter(item => item.signStatus === 2);
                if (arr.length) {
                    return arr[arr.length - 1]
                } else {
                    return null;
                }
            } else {
                return null;
            }
        }
    },
    components: {

    },
    created() {

    },
    mounted() {

    },
    methods: {
        httpRequest(fileObj) {

            let file = fileObj.file;
            if (file.size > 10 * 1024 * 1024) {
                this.$message.error('请上传10M以内的文件');
                return;
            }

            this.$store.commit('showLoading', true);
            var formData = new FormData();
            formData.append("file", file);
            formData.append("contractId", this.contractDetail.info.id);
            formData.append("contractFileId", fileObj.data.id);
            axios({
                method: "post",
                url: '/fileSign/uploadOfflineSignFile',
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.token,
                    "X-CSRF-Token": sessionStorage.token,
                    "request-id": Util.getUID()
                }
            }).then((res) => {
                this.handleSuccess(res, fileObj)
            }, this.handleError);
        },
        // 上传成功
        handleSuccess(res, fileObj) {
            this.uploadFileArray[fileObj.data.index].filePath = res.datas.fileUrl;
            // this.uploadFileArray[fileObj.data.index].fileName = fileObj.file.name;
            this.uploadFileArray[fileObj.data.index].filePathName = fileObj.file.name;
            this.uploadFileArray[fileObj.data.index].isAdd = false;
            this.uploadFileArray[fileObj.data.index].isUpload = true;
            this.$emit("resetFileArray", {
                list: this.uploadFileArray,
                index: fileObj.data.index
            });
            this.$store.commit('showLoading', false);
        },
        // 上传失败
        handleError(res) {
            this.$message.error(res.message);
            this.$store.commit('showLoading', false);
        },


        // 下载全部合同
        downloadAll() {
            BaseApi.createRpcToken(
                "/file/downloadAttachmentZip",
                { id: this.contractDetail.info.id, fileType: 0 },
                "GET",
                false,
                false,
                true,
                "blob"
            )
                .then(
                    res => {
                        console.log(res);
                        this.handlerDownload(res);
                    },
                    () => { }
                )
                .catch(function (e) {
                    console.log(e);
                });
        },
        handlerDownload(res, fileItem = {}) {
            let mimeMap = {
                doc: "application/msword",
                docx:
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                xls: "application/vnd.ms-excel",
                xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            };
            download(
                new Blob([res.data], {
                    type: mimeMap[fileItem.fileFormat] || res.headers["content-type"]
                }),
                fileItem.fileName
                    ? fileItem.fileName + "." + fileItem.fileFormat
                    : `${this.contractDetail.info.name}.zip`,
                mimeMap[fileItem.fileFormat] || res.headers["content-type"]
            );
        },
    }
};
</script>
  
<style lang="scss" scoped>
$red: #C62E3F;
$white: #ffffff;
$gray: #7B7B7B;

.offline-sign {
    height: 100%;
    position: relative;

    .offline-header {
        width: 100%;
        height: 34px;
        line-height: 34px;
        border-bottom: 1px solid #e4e8eb;
        box-sizing: border-box;
        padding: 0 0 0 16px;
    }

    .step-box {
        height: 100%;
        box-sizing: border-box;
        padding-bottom: 64px;
    }

    .step {
        padding: 22px 22px 0 22px;
        height: 100%;
        overflow-y: auto;

        .step-item {
            padding: 0 0 22px 22px;
            border-left: 1px dashed $red;
            position: relative;

            &:last-child {
                padding: 0 0 0 22px;
            }

            .step-index {
                width: 24px;
                height: 24px;
                border-radius: 50%;
                background-color: $red;
                color: $white;
                text-align: center;
                line-height: 24px;
                font-size: 12px;
                position: absolute;
                left: -12px;
                top: 0;
            }

            .step-title {
                display: flex;
                align-items: center;
                font-size: 16px;

                .text {
                    flex: 1;
                }

                .value {
                    display: flex;
                    align-items: center;
                }

                .icon-upload {
                    width: 24px;
                    height: 24px;
                    cursor: pointer;
                }
            }

            .size-tip {
                font-size: 12px;
                color: #999;
                margin-top: 4px;
            }

            .step-content {
                margin-top: 22px;

                .item {
                    width: 100%;
                    margin-bottom: 16px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    .message {
                        display: flex;
                        line-height: 26px;

                        .name {
                            font-size: 14px;
                            flex: 1;
                            color: $gray;
                            word-break: break-all;
                            white-space: pre-wrap;
                        }

                        .icon-pdf {
                            width: 24px;
                            height: 24px;
                            margin-right: 8px;
                        }

                        .icon-upload {
                            width: 24px;
                            height: 24px;
                            cursor: pointer;
                            margin-left: 2px;
                        }
                    }

                    .other-view {
                        width: 218px;
                        background: #F7F8FA;
                        border-radius: 4px;
                        opacity: 1;
                        padding: 5px 5px 5px 16px;
                        box-sizing: border-box;
                        font-size: 14px;
                        color: $gray;
                        margin-top: 4px;
                        word-break: break-all;
                        .tag {
                            margin-left: 8px;
                        }

                        .time {
                            font-size: 14px;
                            color: $gray;
                            margin-top: 4px;
                        }

                    }

                    .red {
                        color: $red;
                    }
                }
            }
        }
    }

    .buttons {
        position: absolute;
        bottom: 0;
        width: 100%;
        box-sizing: border-box;
        text-align: center;
        padding: 16px 0;
        background-color: transparent;
        display: flex;
        justify-content: center;

        .el-button {
            width: 96px;
            margin: 0 16px;
        }

        .submit-button {
            background-color: $red;
            border-color: $red;
        }

        .back-button:hover {
            border-color: #DCDFE6;
            background-color: $white;
            color: #606266;
        }
    }
}

.red {
    color: $red;
}

.bold {
    font-weight: bold;
}
</style>
  